import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: { type: String, default: '' },
    delayMs: { type: Number, default: 0 },
  }

  connect() {
    this.abortController = new AbortController()

    this.fetchTimeout = setTimeout(() => {
      fetch(this.urlValue, {
        signal: this.abortController.signal,
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
        },
      })
        .then((r) => r.text())
        .then((html) => Turbo.renderStreamMessage(html))
        .catch((e) => {
          if (e.name !== 'AbortError') throw e
        })
    }, this.delayMsValue)
  }

  disconnect() {
    clearTimeout(this.fetchTimeout)
    this.abortController.abort()
  }
}
